import { Select } from '@mantine/core';

const sortOptions = [
  // { value: 'New false', label: 'Newest First' },
  { value: 'Price true', label: 'Price (Low - High)' },
  { value: 'Price false', label: 'Price (High - Low)' },
  { value: 'Weight true', label: 'Weight (Low - High)' },
  { value: 'Weight false', label: 'Weight (High - Low)' },
];

function SortDropdown({ value, disabled,onChange, isMobile }) {
  return (
    <Select
      value={value}
      onChange={onChange}
      data={sortOptions}
      disabled={disabled}
      placeholder="Sort by"
      size="sm"
      styles={{
        input: {
          fontSize: isMobile ? '12px' : '14px',
          paddingRight: '1.5rem',
          width: isMobile ? '10rem' : '12rem',
        },
      }}
    />
  );
}

export default SortDropdown;
